import React from "react";
import * as ReactBootStrap from "react-bootstrap";
import "./styles.css";

function Testimonials(){
    return <div>

</div>
}
export default Testimonials;